<div class="container-fluid glb-popup">
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <div class="action-bar">
    <button pButton icon="pi pi-plus" label="Day Column"
    (click)="openAddDayDialog()"></button>

    <button pButton icon="pi pi-plus" label="Row"
    (click)="onOpenFormAdd()"></button>
  </div>

  <hr>

    <div class="card">
      <div class="p-fluid mb-4 ml-4">
        <label style="font-weight: bold;" for="profile">Select Profile to the load table</label>
        <p-dropdown
          name="profile"
          [options]="profileOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="selectedProfileId"
          (onChange)="onProfileChange($event.value)"
          placeholder="Choose Profile"
          appendTo="body"
          [style]="{ width: '250px' }"
          >
        </p-dropdown>
      </div>
      <p-table
        [value]="pivotRows"
        [loading]="loading"
        class="p-datatable-gridlines"
        responsiveLayout="scroll" [editMode]="'cell'">

        <!-- Static columns -->
        <ng-template pTemplate="header">
          <tr>
            <th>LowEndExpOccPCT</th>
            <th>HighEndExpOccPCT</th>
            @for (day of daysList; track day) {
              <th>{{ day }}d
                @if (selectedProfileId) {
                  <button class="p-button-sm p-button-text" (click)="confirmDeleteDay(day)">
                    <i class="pi pi-trash"></i>
                  </button>
                }
              </th>
            }
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ (row.lowEndExpOccPCT * 100) | number:'1.0-0' }}</td>
            <td>{{ (row.highEndExpOccPCT * 100) | number:'1.0-0' }}</td>
            @for (day of daysList; track day) {
              <td>
                @if (row.pctByDay[day]; as m) {
                  <div
                    class="day-cell grid-2"
                    (click)="openDayDetails(row, day)"
                    >
                    <div class="line pct"
                      pTooltip="{{ metricTooltips.pct }}"
                      tooltipPosition="top">
                      {{ formatPct(m.pct) }}
                    </div>
                  </div>
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>